export class MenuHoverEvent {
    
    buttonIsHovered: boolean;
    panelIsHovered: boolean;
    searchBarIsFocused: boolean;
    index: number;

    constructor(buttonIsHovered: boolean, panelIsHovered: boolean, searchBarIsFocused: boolean, index: number) {

        this.buttonIsHovered = buttonIsHovered;
        this.panelIsHovered = panelIsHovered;
        this.searchBarIsFocused = searchBarIsFocused;
        this.index = index;
    }
}